<template>
  <label for>
    <span>{{ label }}</span>
    <section class="form-control replace" :class="{'d-none': $helper.isObject(model[index], this.toEdit)}">
      <input type="button" @click="$refs.fileInput.click()" class="replace-btn" :data-id="index" value="Replace File">
      <span>{{ model[index] }}</span>
    </section>
    <input
      type="file"
      ref="fileInput"
      class="form-control"
      :class="{'d-none': !$helper.isObject(model[index], this.toEdit)}"
      :id="index"
      @change="onFileChange($event, index)"
    />
  </label>
</template>

<script>
export default {
  name: 'InputFileField',
  props: {
    label: { required: true, type: String },
    model: { required: true, type: Object },
    index: { required: true, type: String }
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    }
  },
  data () {
    return {}
  },
  methods: {
    onFileChange (e, index) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.model[index] = null
        index = null
      } else { this.model[index] = files[0] }
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/InputFileField.vue